<div class="container-fluid" id="container-wrapper" style="background-color: white;" *ngIf="userType=='Admin'">

    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Restore Database</h1>
    </div>

    <div style="margin: auto; padding: 20px; margin-top: 10px; margin-bottom: 10px; background-color: #f8f9fa; border-radius: 5px; border: 1px solid #dee2e6;">
        <form [formGroup]="restoreForm" style="width: 100%;">
            <h4 style="text-align: center; margin-bottom: 20px;">Enter Password & Choose the Latest Backup</h4>
            <div class="form-group">
                <input class="form-control" type="password" name="pswd" placeholder="Enter Restore Password" id="passWord" formControlName="passWord">
            </div>

            <div class="form-group">
                <input type="file" class="form-control" (change)="onFileSelected($event)" />
            </div>
            <textarea id="resp" class="form-control" rows="12" readonly style="margin-top: 10px;"></textarea>

        </form>
    </div>
</div>